import { userObj } from '../store'
import { ignoreTimeZoneISOFilter } from '../filters/date/index'

export function getUserSetting() {
  const user = userObj()
  if (!user) return 'EUR'
  return user.profile.dateFormat
}

export function getDateFormat() {
  const dateFormat = getUserSetting()
  if (dateFormat === 'US') return 'MM/DD/YYYY'
  return 'DD/MM/YYYY'
}

export function getShortFormDateFormat() {
  const dateFormat = getUserSetting()
  if (dateFormat === 'US') return 'MM/DD/YY'
  return 'DD/MM/YY'
}

export function getFlatPickrFormat() {
  const dateFormat = getUserSetting()
  const localisedFormat = dateFormat === 'EUR' ? 'd/m/Y' : 'm/d/Y'
  return localisedFormat
}

export function getAngularFilterFormat() {
  const dateFormat = getUserSetting()
  const localisedFormat = dateFormat === 'EUR' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'
  return localisedFormat
}

export function ignoreTimeZoneISO(time) {
  return ignoreTimeZoneISOFilter(time)
}

export function LocalisationFactory() {
  return {
    dateFormat: getDateFormat(),
    userSetting: getUserSetting(),
    shortFormDateFormat: getShortFormDateFormat(),
    getLocalisationPreferences: function () {
      return {
        dateFormat: getDateFormat(),
        userSetting: getUserSetting(),
        shortFormDateFormat: getShortFormDateFormat(),
        flatPickrFormat: getFlatPickrFormat(),
        angularFilterFormat: getAngularFilterFormat(),
      }
    },
    ignoreTimeZoneISO: ignoreTimeZoneISO,
  }
}
